module.exports = __webpack_public_path__ + "static/media/icon-success.9f77a1d6.svg";